import { useMemo } from 'react';
import { useNavigate } from 'react-router';
import { type RouteNamesKey } from '../routesNames';
import { getRoutePath } from '../routes';

export function useRouter() {
  const navigate = useNavigate();

  const router = useMemo(
    () => ({
      back: () => navigate(-1),
      forward: () => navigate(1),
      refresh: () => navigate(0),
      push: (name: RouteNamesKey, params?: Record<string, string | number>) => {
        const path = getRoutePath(name, params);
        void navigate(path);
      },
      replace: (name: RouteNamesKey, params?: Record<string, string | number>) => {
        const path = getRoutePath(name, params);
        void navigate(path, { replace: true });
      },
    }),
    [navigate],
  );

  return router;
}
